import { parseHdmiPort } from './launcherTopology';

export async function prepareScreenSource({ screen, targetDeviceId, readState, activate, stillSelected }) {
  if (Number(targetDeviceId) === Number(screen.televisionDeviceId)) return;
  const player = (screen.players || []).find((entry) => Number(entry.deviceId || entry.id) === Number(targetDeviceId));
  const expectedPort = parseHdmiPort(player?.expectedInput);
  let state;
  if (expectedPort && screen.televisionDeviceId) {
    try {
      state = await readState(screen.televisionDeviceId);
    } catch (_error) {
      // Missing live evidence retains the configured activation and verification path.
    }
  }
  if (!stillSelected()) throw new Error('Selection changed; content was not launched.');
  const inputManager = state?.tvInputManager;
  const active = inputManager?.activeSource;
  if (expectedPort && active?.available === true && active.isStale !== true
    && inputManager.isStale !== true && Number(active.port) === expectedPort) return;
  await activate();
}

// A warning is acceptable only when source activation itself was positively verified.
export function sourceActivationVerified(operation) {
  return ['succeeded', 'succeeded_with_warnings'].includes(operation?.status)
    && !operation?.result?.incomplete
    && operation.steps?.some((step) => step.action === 'activate_source' && step.status === 'succeeded' && step.evidence?.verified === true);
}

export async function waitForSourceActivation({ operation, read, stillSelected, now = Date.now,
  sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms)) }) {
  const deadline = Math.min(operation?.deadlineMs || now() + 300000, now() + 300000);
  let current = operation;
  while (current?.status === 'running' && !current.stale && now() < deadline) {
    if (!stillSelected()) throw new Error('Selection changed; content was not launched. Check the Screen routine.');
    await sleep(1000);
    current = await read(current.id);
  }
  if (!stillSelected() || !sourceActivationVerified(current)) {
    throw new Error('Source activation was not verified. Content was not launched; check the Screen routine before retrying.');
  }
  return current;
}
